import { Flex } from '@mantine/core';
import React from 'react';

export const CircledIcon = ({ icon }: { icon: React.ReactNode }) => {
  return (
    <Flex direction={'row'} justify={'center'}>
      <div
        style={{
          borderRadius: '50%',
          border: '1px solid var(--mantine-color-otherGrey10-0)',
          padding: '28px',
          marginBottom: 'var(--mantine-spacing-lg)',
        }}
      >
        <div
          style={{
            boxSizing: 'content-box',
            height: '48px',
            borderRadius: '50%',
            border: '1px solid var(--mantine-color-otherGrey20-0)',
            padding: '28px',
          }}
        >
          {icon}
        </div>
      </div>
    </Flex>
  );
};
